import React, { useState, useEffect } from "react";
import "../style/GeneradorDocumentos.css";
import TopBarHeader from "../components/TopBarHeader";
import VisorPDF from "../components/VisorPDF";
import payloadData from "../assets/payload-test.json";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const API_STAGE = process.env.REACT_APP_STAGE;
const API_KEY = process.env.REACT_APP_API_KEY;

function GeneradorDocumentos() {
  const [documentos, setDocumentos] = useState([]);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState("");
  const [variables, setVariables] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  // Estado para almacenar los datos del PDF
  const [pdfData, setPdfData] = useState(null);
  const [pdfDataBase64, setPdfDataBase64] = useState(null);
  const [cargandoTemplates, setCargandoTemplates] = useState(false);

  useEffect(() => {
    // Cambia la URL por la URL real de tu API
    const url = BASE_URL + "/" + API_STAGE + "/google-docs/template";
    const apiKey = API_KEY; // Reemplaza con tu propia API key

    const headers = {
      "x-api-key": apiKey,
      Accept: "application/json",
      // Otros headers que tu API pueda necesitar
    };

    const cargarDocumentos = async () => {
      setCargando(true); // Inicia el indicador de carga
      try {
        const respuesta = await fetch(url, { headers });

        if (!respuesta.ok) {
          throw new Error(`HTTP error! status: ${respuesta.status}`);
        }
        const resultado = await respuesta.json();
        setDocumentos(resultado.body); // Asumiendo que 'body' es el array que contiene los documentos
      } catch (error) {
        setError(error.message);
      } finally {
        setCargando(false);
      }
    };

    cargarDocumentos();
  }, []); // El array vacío asegura que el efecto se ejecute solo una vez al montar

  useEffect(() => {
    const documento = documentos.find(
      (doc) => doc.id === documentoSeleccionado
    );

    if (documento) {
      // Utiliza un conjunto (Set) para filtrar nombres de variables únicos
      const variablesUnicas = new Set(documento.variables);
      setVariables([...variablesUnicas]);
    } else {
      setVariables([]);
    }
  }, [documentoSeleccionado, documentos]);

  const handleChange = (event) => {
    setDocumentoSeleccionado(event.target.value);
  };

  // Estado para almacenar los valores de las variables
  const [valoresVariables, setValoresVariables] = useState({});

  // Esta función carga los datos en los inputs haciendo match con payloadData
  const cargarDatos = () => {
    const nuevosValores = variables.reduce((acc, variable) => {
      acc[variable] = payloadData[variable] || ""; // Usa un valor vacío como fallback
      return acc;
    }, {});
    setValoresVariables(nuevosValores);
  };

  const limpiarDatos = () => {
    const inputsVacios = variables.reduce((acc, variable) => {
      acc[variable] = ""; // Establece todos los inputs a cadena vacía
      return acc;
    }, {});
    setValoresVariables(inputsVacios);
  };

  const todasVariablesCompletas = variables.every(
    (variable) =>
      valoresVariables[variable] && valoresVariables[variable].trim() !== ""
  );

  const crearDocumento = async () => {
    setCargando(true); // Comenzamos a cargar

    const url = `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_STAGE}/google-docs/doc`;

    const opciones = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY, // Asegúrate de tener esta variable de entorno configurada
      },
      body: JSON.stringify({
        templateId: documentoSeleccionado,
        ...valoresVariables,
      }),
    };

    try {
      const respuesta = await fetch(url, opciones);
      if (!respuesta.ok) {
        throw new Error("Error en la solicitud: " + respuesta.statusText);
      }
      const resultado = await respuesta.json();

      if (resultado.statusCode === 200 && resultado.file) {
        const pdfData = base64ToArrayBuffer(resultado.file);
        // Ahora, pdfData es un ArrayBuffer que puedes pasar a react-pdf
        setPdfData(pdfData); // Asegúrate de tener un estado llamado pdfData para esto
        setPdfDataBase64(resultado.file); // Asegúrate de tener un estado llamado pdfData para esto
      }
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      // Manejo de errores, como mostrar un mensaje de error al usuario
    } finally {
      setCargando(false); // Terminamos de cargar, sin importar el resultado
    }
  };

  function base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  function base64ToBlob(base64, mimeType) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    return blob;
  }

  function descargarPDF(base64, nombreArchivo) {
    // Asegúrate de remover el prefijo de datos si está presente en tu base64
    const base64Data = base64.split(";base64,").pop();

    const blob = base64ToBlob(base64Data, "application/pdf");
    const url = URL.createObjectURL(blob);

    // Crea un elemento de enlace para iniciar la descarga
    const link = document.createElement("a");
    link.href = url;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();

    // Limpieza después de la descarga
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  return (
    <div>
      {cargando && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}

      <TopBarHeader />

      <h1 className="h1-titulo-2">Generador de Documentos</h1>
      <p className="description">
        Automatiza la creación de tus documentos usando plantillas de Google
        Docs.
      </p>
      <select
        className="selector-template"
        value={documentoSeleccionado}
        onChange={handleChange}
      >
        <option value="">Seleccione un documento...</option>
        {documentos.map((doc) => (
          <option key={doc.id} value={doc.id}>
            {doc.name}
          </option>
        ))}
      </select>
      <div>
        {variables.length > 0 && (
          <details close>
            <summary>Variables del Documento</summary>
            <div className="grid-container">
              {variables.map((variable, index) => (
                <div key={index} className="grid-item">
                  <label>{variable}</label>
                  <input
                    type="text"
                    value={valoresVariables[variable] || ""}
                    onChange={(e) =>
                      setValoresVariables({
                        ...valoresVariables,
                        [variable]: e.target.value,
                      })
                    }
                    placeholder={`Ingrese ${variable}`}
                  />
                </div>
              ))}
            </div>
          </details>
        )}

        {documentoSeleccionado && (
          <>
            <button
              className="button"
              onClick={cargarDatos}
              disabled={!documentoSeleccionado}
            >
              Cargar Datos de Prueba
            </button>
            <button
              className="button"
              onClick={limpiarDatos}
              disabled={!documentoSeleccionado}
            >
              Limpiar
            </button>
            <button
              className="button-submit"
              onClick={crearDocumento}
              disabled={!documentoSeleccionado || !todasVariablesCompletas}
            >
              Crear Documento
            </button>
            <button
              className="button"
              onClick={() => descargarPDF(pdfDataBase64, "descarga.pdf")}
              disabled={!pdfData}
            >
              Descargar PDF
            </button>
          </>
        )}
      </div>
      {pdfData && <VisorPDF archivo={pdfData} />}
    </div>
  );
}

export default GeneradorDocumentos;
